export var IframeQueryParameters;
(function (IframeQueryParameters) {
    IframeQueryParameters["nodeId"] = "nodeId";
    IframeQueryParameters["versionId"] = "versionId";
    IframeQueryParameters["referral"] = "referral";
    IframeQueryParameters["isChatbotOpen"] = "isChatbotOpen";
    IframeQueryParameters["loadPageUrl"] = "loadPageUrl";
    IframeQueryParameters["applyUrlToRouter"] = "applyUrlToRouter";
    IframeQueryParameters["provideRuntimeDataFromSDK"] = "provideRuntimeDataFromSDK";
})(IframeQueryParameters || (IframeQueryParameters = {}));
export var RouterOptions;
(function (RouterOptions) {
    RouterOptions["NewRoute"] = "newRoute";
    RouterOptions["ModifyRouteParams"] = "modifyRouteParams";
})(RouterOptions || (RouterOptions = {}));
export var AllowedUserActionRunners;
(function (AllowedUserActionRunners) {
    AllowedUserActionRunners["USP"] = "usp";
})(AllowedUserActionRunners || (AllowedUserActionRunners = {}));
//# sourceMappingURL=iframeQueryParameters.js.map